import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-error-state',
  standalone: true,
  imports: [],
  template: `
    <div class="error-container">
      <div class="error-icon">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="48"
          height="48"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round">
          <circle cx="12" cy="12" r="10"></circle>
          <line x1="12" y1="8" x2="12" y2="12"></line>
          <line x1="12" y1="16" x2="12.01" y2="16"></line>
        </svg>
      </div>
      <h2 class="error-title">{{ title }}</h2>
      <p class="error-message">{{ message }}</p>
      <button class="retry-button" (click)="onRetry()">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round">
          <polyline points="23 4 23 10 17 10"></polyline>
          <polyline points="1 20 1 14 7 14"></polyline>
          <path
            d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"></path>
        </svg>
        Try Again
      </button>
    </div>
  `,
  styles: [
    `
      .error-container {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        padding: 80px 24px;
        flex: 1;
        text-align: center;
      }

      .error-icon {
        margin-bottom: 16px;
        color: #ef4444;
      }

      .error-title {
        font-size: 20px;
        font-weight: 600;
        color: #1a1a2e;
        margin: 0 0 8px 0;
        font-family: var(
          --ukg_sys_fontFamily_primaryTight,
          -apple-system,
          BlinkMacSystemFont,
          'Segoe UI',
          sans-serif
        );
      }

      .error-message {
        font-size: 14px;
        color: #6b7280;
        margin: 0;
        font-family: var(
          --ukg_sys_fontFamily_primaryTight,
          -apple-system,
          BlinkMacSystemFont,
          'Segoe UI',
          sans-serif
        );
      }

      .retry-button {
        margin-top: 16px;
        padding: 10px 20px;
        background: #2563eb;
        color: white;
        border: none;
        border-radius: 6px;
        font-size: 14px;
        font-weight: 500;
        cursor: pointer;
        font-family: var(
          --ukg_sys_fontFamily_primaryTight,
          -apple-system,
          BlinkMacSystemFont,
          'Segoe UI',
          sans-serif
        );
        display: flex;
        align-items: center;
        gap: 8px;
      }

      .retry-button:hover {
        background: #1d4ed8;
      }
    `,
  ],
})
export class ErrorStateComponent {
  @Input() title = 'Unable to Load Data';
  @Input() message = 'An error occurred while loading data.';
  @Output() retry = new EventEmitter<void>();

  onRetry(): void {
    this.retry.emit();
  }
}
